import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { ProductoInterface } from "../../interfaces/productoInterfaces/Producto.interface";

export async function ToggleDestacadoProductoAction(
  idProducto: string
): Promise<ApiResponse<ProductoInterface>> {
  const { data } = await apiClient.patch<ProductoInterface>(
    `gpProductos/${idProducto}/toggleDestacado`
  );
  return {
    status: 200,
    data,
    message:
      "Visibilidad de producto actualizada correctamente",
  };
}
